<template>
  <v-container class="mb-2">
    <v-row class="my-3">
      <label class="font-italic">Buckets</label>

      <v-btn icon x-small @click="addQuestion" color="primary">
        <v-icon> mdi-plus-circle </v-icon>
      </v-btn>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="questions"
      sort-by="sequence"
      v-sortable-data-table
      @sorted="saveOrder"
      item-key="questionId"
      :items-per-page="-1"
      hide-default-header
      hide-default-footer
      no-data-text="No buckets added"
      class="primary--text"
      :key="questions.length"
    >
      <template v-slot:[`item.question`]="{ item, index }">
        <form-field
          :field="simpleTextEditor(item)"
          :validations="validations"
          @fieldChange="updateQuestion(index, item, $event)"
          class="pa-3"
        ></form-field>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          :disabled="questions.length < 2"
          icon
          small
          @click="deleteQuestion(item)"
          color="primary"
          ><v-icon small> mdi-delete</v-icon></v-btn
        >
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import Question from "../../objs/Question";
import { required } from "../../plugins/vee-validate/validation";
import FormField from "../../objs/Shared/FormField";
import Sortable from "sortablejs";

export default {
  props: ["groupQuestion"],
  data() {
    return {
      questions: [],
      validations: { required: true },
      headers: [
        { text: "Sequence", value: "sequence" },
        { text: "Question", value: "question" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  mounted() {
    if (Boolean(this.groupQuestion)) {
      this.questions = [
        ...this.groupQuestion?.childQuestions.sort(
          (a, b) => a.sequence - b.sequence
        ),
      ];
    } else
      this.questions = [
        new Question({
          sequence: 1,
        }),
      ];
  },
  computed: {
    lastSequence() {
      return Math.max(...this.questions.map((x) => x.sequence), 0);
    },
  },
  methods: {
    simpleTextEditor: function (question) {
      return new FormField({
        value: question.label,
        componentName: "simple-text-editor",
      });
    },
    questionsChange: function () {
      this.$emit("childQuestionsChange", this.questions);
    },
    updateQuestion: function (index, question, newValue) {
      this.questions.splice(
        index,
        1,
        new Question({ ...question, label: newValue })
      );
      this.questionsChange();
    },
    addQuestion: function () {
      this.questions.push(
        new Question({
          groupQuestionId: this.groupQuestion?.questionId,
          sequence: this.lastSequence + 1,
        })
      );
      this.questionsChange();
    },
    deleteQuestion: function (item) {
      this.questions = this.questions
        .filter((x) => x != item)
        .map((x, i) => new Question({ ...x, sequence: i + 1 }));
      this.questionsChange();
    },
    saveOrder(event) {
      const movedItem = this.questions.splice(event.oldIndex, 1)[0];
      this.questions.splice(event.newIndex, 0, movedItem);

      // reorder all questions
      this.questions = this.questions
        .map((x, i) => new Question({ ...x, sequence: i + 1 }))
        .sort((a, b) => a.sequence - b.sequence);

      this.questionsChange();
    },
  },
  directives: {
    sortableDataTable: {
      bind(el, binding, vnode) {
        const questions = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit("sorted", event);
          },
        };
        Sortable.create(el.getElementsByTagName("tbody")[0], questions);
      },
    },
  },
};
</script>
